import client from "../../client/client";

class PackageManagementService {
	createPackage(payload, cancelToken) {
		return client.post("/backoffice/packages", { payload, config: { cancelToken } });
	}

	updatePackage({ packageId }, payload, cancelToken) {
		return client.put(`/backoffice/packages/${packageId}`, { payload, config: { cancelToken } });
	}

	getActivePackageCompanies({ packageId }, cancelToken) {
		return client.get(`/backoffice/packages/${packageId}/companies`, { config: { cancelToken } });
	}

	updateActivePackageCompanies({ packageId }, payload, cancelToken) {
		return client.put(`/backoffice/packages/${packageId}/companies`, { payload, config: { cancelToken } });
	}

	getPackageFeatures({ packageId }, cancelToken) {
		return client.get(`/backoffice/packages/${packageId}/features`, { config: { cancelToken } });
	}

	updatePackageFeatures({ packageId }, payload, cancelToken) {
		return client.put(`/backoffice/packages/${packageId}/features`, { payload, config: { cancelToken } });
	}

	getActivePackageProjects({ packageId }, { page = 0, limit = 15, filter }, cancelToken) {
		return client.get(`/backoffice/packages/${packageId}/projects`, {
			params: { page, limit, filter },
			config: { cancelToken },
		});
	}

	getAllPlatformPackages(name, cancelToken) {
		return client.get("/backoffice/packages/all", { params: { name }, config: { cancelToken } });
	}

	updatePackageOrder(payload, cancelToken) {
		return client.put("/backoffice/packages/order", { payload, config: { cancelToken } });
	}

	getAvailablePackages(cancelToken) {
		return client.get("/packages/available", { config: { cancelToken } });
	}
}
export default new PackageManagementService();
